export const module = {
  crm: "crm",
  marginMachine: "marginMachine",
};
